export default "__VITE_ASSET__CeI2C0tn__"